import React, { useState } from 'react';
import MeetingLoading from 'src/assets/imgs/loading.gif';
import './index.scss';

const ToastIcon = () => {
  const [imgErr, setImgErr] = useState(false);
  return (
    <div className="logo">
      {imgErr ? (
        <svg viewBox="25 25 50 50" className="circular">
          <circle cx="50" cy="50" r="20" fill="none" className="path" />
        </svg>
      ) : (
        <img src={MeetingLoading} onError={() => setImgErr(true)} />
      )}
    </div>
  );
};

export default ToastIcon;
